import { HttpLoader } from './http-loader';
import { TranslateConfig } from './translate-config';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { EnvironmentProviders, Provider } from '@angular/core';

export const translateProvider = [
  provideTransloco({
    config: TranslateConfig,
    loader: HttpLoader,
  }),
  provideTranslocoMessageformat(),
];

export function provideTranslocoConfig(): Array<Provider | EnvironmentProviders> {
  return [
    provideTransloco({
      config: TranslateConfig,
      loader: HttpLoader,
    }),
    provideTranslocoMessageformat(),
  ];
}
